import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

const propTypes = {
  crumb: PropTypes.shape({
    label: PropTypes.node.isRequired,
    path: PropTypes.string,
    separator: PropTypes.bool,
    onClick: PropTypes.func,
    active: PropTypes.bool,
  }).isRequired,
};

const NavigationBreadcrumbsItemLabel = ({ crumb }) => {
  const classes = classNames({
    'navigation-breadcrumbs-item-label': true,
  });
  const { label, path, onClick } = crumb;
  const titleAttribute = typeof label === 'string' ? label : undefined;

  if (path) {
    return (
      <NavLink
        exact
        activeClassName="navigation-breadcrumbs-item-active"
        className={classes}
        onClick={onClick}
        to={path}
        title={titleAttribute}
      >
        {label}
      </NavLink>
    );
  }

  return onClick ? (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
      title={titleAttribute}
    >
      {label}
    </a>
  ) : (
    <span className={classes} title={label}>
      {titleAttribute}
    </span>
  );
};

NavigationBreadcrumbsItemLabel.propTypes = propTypes;

export default NavigationBreadcrumbsItemLabel;
